<template>
    <div>
        <div class="HeaderLine" v-if="FixedBlon"></div>
        <div class="Header" :class="{Fixed:FixedBlon}">
            <div class="MaxWid">
                <div class="Logo">
                    <div class="LogoImg">
                        <img src="../../assets/img/logo.jpg" alt="">
                        <div class="LogoTxt">
                            <p>中国心理卫生协会心理服务专业机构和专业人员注册系统</p>
                            <p>Registration for Psychological Service Institutions and Professionals of CAMH (RPS)</p>
                            <!-- <div class="LogoTxt1">
                                 <p>Registration for Psychological Service Institutions and Professionals of CAMH (RPS)</p>
                            </div> -->
                            <!-- <p>中国心理卫生协会心理服务专业机构和专业人员注册系统</p> -->
                        </div>
                    </div>
                    <div v-if="Act!=0">
                        <div class="LoginBtn" v-if="!User">
                            <span @click="ToggleNav(9)">注册</span>
                            <span @click="ToggleNav(10)">登录</span>
                        </div>
                        <div class="header-user-Cont" v-if="User">
                            <div class="header-user">{{ User }}</div>
                            <div class="header-user-center" @click="goToUserInfo">个人中心</div>
                        </div>
                    </div>
                    
                    <div class="iconfont icon-liebiao NavBlon" @click="drawer = true"></div>
                </div>
                <div class="NavHead">
                    <div class="NavCont">
                        <div class="NavItem" :class="{'Act':i==1}" @click="ToggleNav(1)">首页</div>
                        <div class="NavItem" :class="{'Act':i==2}" @click="ToggleNav(2)">关于我们</div>
                        <div class="NavItem" :class="{'Act':i==3}" @click="ToggleNav(3)">注册申请</div>
                        <div class="NavItem" :class="{'Act':i==4}" @click="ToggleNav(4)">注册查询</div>
                        <div class="NavItem" :class="{'Act':i==5}" @click="ToggleNav(5)">继续教育</div>
                        <div class="NavItem" :class="{'Act':i==6}" @click="ToggleNav(6)">信息动态</div>
                        <div class="NavItem" :class="{'Act':i==7}" @click="ToggleNav(7)">职业伦理</div>
                        <div class="NavItem" :class="{'Act':i==8}" @click="ToggleNav(8)">公示信息</div>
                    </div>
                    <!-- <div class="Search">
                        <div class="iconfont icon-sousuo-copy"></div>
                    </div> -->
                </div>
            </div>
        </div>
        <el-drawer :visible.sync="drawer" direction="ltr" :with-header="false"size="70%" :modal-append-to-body="false">
            <div class="MbNav">
                <div class="NavItem" @click="ToggleNav(1)">首页</div>
                <div class="NavItem" @click="ToggleNav(2)">关于我们</div>
                <div class="NavItem" @click="ToggleNav(3)">申请注册</div>
                <div class="NavItem" @click="ToggleNav(4)">注册查询</div>
                <div class="NavItem" @click="ToggleNav(5)">继续教育</div>
                <div class="NavItem" @click="ToggleNav(6)">信息动态</div>
                <div class="NavItem" @click="ToggleNav(7)">职业伦理</div>
                <div class="NavItem" @click="ToggleNav(8)">公示信息</div>
                <div class="NavItem" @click="ToggleNav(9)" v-if="!User">注册</div>
                <div class="NavItem" @click="ToggleNav(10)" v-if="!User">登录</div>
                <div class="NavItem" @click="goToUserInfo" v-if="User">个人中心</div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
    export default {
        props: ['Act'],
        data() {
            return {
                i:1,
                User: "",
                FixedBlon:false,
                drawer:false,
            }
        },
        mounted() {  
            this.i = this.Act;
            this.User = localStorage.getItem("User")?JSON.parse(localStorage.getItem("User")).userinfo.nickname:"";
        },  
        created() {
            window.addEventListener('scroll', this.handleScroll); 
        },
        methods: {
            ToggleNav(i){
                this.i = i;
                switch(i) {
                    case 1:
                        this.GoPage("/")
                        break;
                    case 2:
                        this.GoPage("/About")
                        break;
                    case 3:
                        this.GoPage("/ApplyReg")
                       break;
                    case 4:
                        this.GoPage("/RegQuery")
                        break;
                    case 5:
                        this.GoPage("/Education")
                        break;
                    case 6:
                        this.GoPage("/InfoState")
                      break;
                    case 7:
                        this.GoPage("/Profession")
                    break;
                    case 8:
                        this.GoPage("/Publicity")
                    break;
                    case 9:
                        this.GoPage("/Reg")
                        break;
                    break;
                    case 10:
                        this.GoPage("/Login")
                        break;
                    break;
                } 
            },
            handleScroll() {  
                 if (window.scrollY > 99) {  
                     this.FixedBlon = true;
                 } else {  
                   this.FixedBlon = false;
                 }
            },
            UpData(){
                this.User = localStorage.getItem("User")?JSON.parse(localStorage.getItem("User")).userinfo.nickname:"";
            },
            //跳转
            GoPage(url) {
                if(this.$route.path != url){
                    window.scrollTo({top: 0});
                    this.$router.push({ path: url});
                }
            },
            goToUserInfo() {
                if(this.$route.path !== '/UserInfo') {
                    this.$router.push('/UserInfo');
                }
            },
        },
    }
</script>
<style>
    .el-drawer{
        background: rgba(0,0,0,0.8);
    }
</style>
<style scoped>
    .HeaderLine{
        height: 120px;
    }
    .Header{
        background: #fff;
        width: 100%;
        
    }
    .Header.Fixed{
        position: fixed;
        top: 0;
        z-index: 9;
    }
    .MaxWid{
        max-width: 1180px;
        padding: 0 10px;
        margin: 0 auto;
    }
    .Logo{
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-top: 10px;
    }
    .LogoImg{
        display: flex;
        align-items: center;
        flex: 1;
    }
    .LogoImg img{
        width: 60px;
        margin-right: 20px;
    }
    .LogoTxt{
        line-height: 24px;
    }
    .LogoTxt p:first-child {
        font-size: 15px;
        letter-spacing: 3px;
        /* font-weight: bold; */
    }
    .LogoTxt p:last-child {
        font-size: 12px;
    }
    /* .LogoTxt .LogoTxt1{
        line-height: 24px;
        font-size: 12px;
    } */
    .LoginBtn{
        display: flex;
        align-items: center;
        gap: 1rem;
    }
    .LoginBtn span{
        color: #0185eb;
        font-size: 16px;
        cursor: pointer;
    }
    .header-user-Cont {
        display: flex;
        align-items: center;
        gap: 20px;
    }
    
    .header-user {
        font-size: 16px;
        color: #333;
    }
    
    .header-user-center {
        padding: 8px 16px;
        background: #0185eb;
        color: #fff;
        border-radius: 4px;
        font-size: 14px;
        cursor: pointer;
        transition: background-color 0.3s;
    }
    
    .header-user-center:hover {
        background: #0168c7;
    }
    .NavBlon{
        display: none;
    }
    .NavHead{
        margin-top: 10px;
        display: flex;
        align-items: center;
        justify-content: space-between
    }
    .NavCont{
        display: flex;
        align-items: center;
        flex: 1;
    }
    .NavItem{
        padding: 10px 0;
        font-size: 16px;
        cursor: pointer;
        flex: 1;
        text-align: center;
    }
    .NavItem:hover{
        background: #0185eb;
        color: #fff;
    }
    .NavItem.Act{
        background: #0185eb;
        color: #fff;
    }
    .Search .iconfont{
        font-size: 24px;
        color: #ef8402;
        font-weight: 700;
        cursor: pointer;
    }
    @media (min-width: 550px) and (max-width: 980px) {  
        .NavItem{
            font-size: 16px;
            margin-right: 1.2vw;
        }
    }
    @media only screen and (max-width: 550px){
      /*  .Logo{
            display: block;
        } */
        .LogoImg{
            width: 200px;
        }
        .header-user-Cont,
        .LoginBtn{
            display: none;
        }
        .LoginBtn span:last-child{
            margin-right: 0;
        }
        .NavHead{
            display: none;
        }
        .NavBlon{
            display: block;
            font-size: 30px;
            color: #ef8402;
        }
        .NavItem{
            color: #fff;
            padding: 10px;
            border-bottom: 1px solid #fff;
            text-align: left;
        }
    }
</style>